import * as yup from "yup";

export const ruleValidationSchema =
    yup.object({
        name: yup
            .string()
            .required('message.validation.required'),
        bookingDateFrom: yup
            .date()
            .typeError('message.validation.invalid_date')
            .nullable()
            .required('message.validation.required'),
        bookingDateTo: yup
            .date()
            .typeError('message.validation.invalid_date')
            .nullable(),
        pickupDateTimeFrom: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .date()
                        .typeError('message.validation.invalid_date')
                        .nullable()
                        .required('message.validation.required')
                })
            }),
        pickupDateTimeTo: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .date()
                        .typeError('message.validation.invalid_date')
                        .nullable()
                        .required('message.validation.required')
                })
            }),
        dropoffDateTimeFrom: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .date()
                        .typeError('message.validation.invalid_date')
                        .nullable()
                        .required('message.validation.required')
                })
            }),
        dropoffDateTimeTo: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .date()
                        .typeError('message.validation.invalid_date')
                        .nullable()
                        .required('message.validation.required')
                })
            }),
        includingDateTimeFrom: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .date()
                        .typeError('message.validation.invalid_date')
                        .nullable()
                        .required('message.validation.required')
                })
            }),
        includingDateTimeTo: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .date()
                        .typeError('message.validation.invalid_date')
                        .nullable()
                        .required('message.validation.required')
                })
            }),
        pickupLocations: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        dropoffLocations: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        pickupAreas: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        dropoffAreas: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        pickupRegions: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        dropoffRegions: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        pickupZones: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        dropoffZones: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        acrissList: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        sippList: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        customerCodes: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        salesChannels: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        segments: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        categories: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        products: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        rates: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        ancillaries: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .array()
                        .min(1, 'message.validation.required')
                })
            }),
        minDuration: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .number()
                        .min(1, 'message.validation.required')
                })
            }),
        maxDuration: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .number()
                        .min(1, 'message.validation.required')
                })
            }),
        minNoticeDays: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .number()
                        .min(1, 'message.validation.required')
                })
            }),
        maxNoticeHours: yup
            .object()
            .when({
                is: undefined,
                then: schema => schema,
                otherwise: yup.object({
                    value: yup
                        .number()
                        .min(1, 'message.validation.required')
                })
            }),
        tenants: yup
            .array()
            .min(1, 'message.validation.required'),
        dealers: yup
            .array()
            .min(1, 'message.validation.required')
    })
;